import React from 'react'
import { BadgeInfoIcon } from '../../images'
import { CheckCheckIcon } from '../../images'

const getVariantIcon = (variant) => {
  switch (variant) {
    case 'warning':
    case 'info':
      return <BadgeInfoIcon width={14} height={14} />
    case 'success':
      return <CheckCheckIcon width={14} height={14} />
    default:
      return <BadgeInfoIcon width={14} height={14} />
  }
}

const InfoMessage = ({ text, variant = 'warning', className = '', style = {} }) => {
  return (
    <div className={`info-message ${variant} ${className}`} style={style}>
      {getVariantIcon(variant)}

      <span className="text">{text}</span>
    </div>
  )
}

export default InfoMessage